import Skeleton from "@mui/material/Skeleton";

import { IconSkeleton } from "./Article";

export default function Discussion() {
	return (
		<div>
			<IconSkeleton />
			<Skeleton variant="text" height={20} />
			<Skeleton variant="rounded" height={60} />
			<Skeleton variant="text" height={20} />
			<Skeleton variant="text" height={20} />
		</div>
	);
}
